import { Suspense } from 'react';
import { Outlet } from 'react-router';
import { Toaster } from '@/components/Toaster';
import { Spinner } from '@/components/ui/Spinner';
import { Header } from './Header';
import { Sidebar } from './Sidebar';

/** Fixed 230px sidebar, green header, grey content canvas — the AP admin shell. */
export function AppLayout() {
  return (
    <div className="min-h-screen bg-white shadow-shell">
      <Sidebar />
      <div className="flex min-h-screen flex-col lg:ml-sidebar">
        <Header />
        <main className="flex-1 bg-canvas p-4 sm:p-5">
          <Suspense
            fallback={
              <div className="flex justify-center py-16">
                <Spinner className="size-7 text-brand" />
              </div>
            }
          >
            <Outlet />
          </Suspense>
        </main>
      </div>
      <Toaster />
    </div>
  );
}
